import { render } from "./index.vue?vue&type=template&id=fb7837cc&scoped=true?status=20"
import script from "./index.vue?vue&type=script&lang=js?status=20"
export * from "./index.vue?vue&type=script&lang=js?status=20"

import "./index.vue?vue&type=style&index=0&id=fb7837cc&lang=less&scoped=true?status=20"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7837cc"]])

export default __exports__